import React, { useEffect, useRef, useState } from "react";
import { io, Socket } from "socket.io-client";
import axios from "axios";
import { notification } from "antd";
 
const SOCKET_URL = "https://mis-test.iatsolutions.co:9998";
const SOCKET_PATH = "/sockets";
 
// ✅ Configure global notification style
notification.config({
  placement: "bottomRight",
  bottom: 100,
  duration: 5,
});
 
const SocketListener: React.FC = () => {
  const socketRef = useRef<Socket | null>(null);
  const connectedRef = useRef(false);
  const [showButton, setShowButton] = useState(false);
 
  useEffect(() => {
    // Show button only if logged in
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    setShowButton(Boolean(token && user));
 
    if (connectedRef.current) return;
    connectedRef.current = true;
 
    const socket = io(SOCKET_URL, {
      path: SOCKET_PATH,
      transports: ["websocket"],
    });
 
    socketRef.current = socket;
 
    socket.on("connect", () => {
    });
 
    socket.on("disconnect", (reason) => {
    });
 
    socket.on("connect_error", (err) => {
      console.error("🚨 connect_error:", err);
    });
 
    // ✅ Listen for broadcast messages
    socket.on("broadcast", (data: any) => {
      const msg = data?.msg ?? JSON.stringify(data);
      const ts = new Date().toLocaleString();
      const key = `broadcast_${Date.now()}`;
 
      notification.open({
        key,
        message: "📡 System Notification",
        description: (
          <div>
            <div style={{ fontWeight: 600 }}>{msg}</div>
            <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
              Received: {ts}
            </div>
          </div>
        ),
        duration: 5,
        onClick: () => window.focus(),
      });
    });
 
    return () => {
      socket.disconnect();
      connectedRef.current = false;
      socketRef.current = null;
    };
  }, []);
 
  // ✅ Manual test button
  const sendSocketTest = async () => {
    const url = `${SOCKET_URL}/socket/test_socket_to_client?name= `;
    try {
      const resp = await axios.post(url, {}, { headers: { Accept: "application/json" } });
      notification.success({
        message: "Test Broadcast Sent",
        description: "Check your notifications for the broadcast.",
      });
    } catch (err: any) {
      console.error("❌ Test endpoint error:", err?.response?.data ?? err.message);
      notification.error({
        message: "Test Broadcast Failed",
        description: String(err?.message ?? err),
      });
    }
  };
 
  return (
    <div
      className="position-fixed bottom-0 end-0 p-3 d-flex flex-column align-items-end gap-2"
      style={{ zIndex: 1050 }}
    >
      {showButton && (
        <button
          className="btn btn-primary rounded-circle shadow"
          style={{ width: "48px", height: "48px" }}
          onClick={sendSocketTest}
        >
          <i className="fa fa-refresh"></i>
        </button>
      )}
    </div>
  );
};
 
export default SocketListener;